import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'b69973d1-d62f-4fd2-89a8-1dfed090b6be',
    countryCodes: ['ES'],
    locale: 'es-ES',
    isPrive: true,
});
